import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/teacherUnavailabilitys";

export default {
  async delete(id) {
    return await HTTP.delete(`${RESOURCE_NAME}/${id}`);
  },
};
